import { useEffect } from "react";
import { MdPhone } from "react-icons/md";

import type { CallDto } from "~/data/call/call.dto";

import ringSound from "~/ui/shared/assets/sounds/ring.mp3";

import { UserAvatar } from "../shared/user-avatar";

interface IncomingCallProps {
  call: CallDto;
  onAccept(): void;
  onReject(): void;
}

export function IncomingCall({ call, onAccept, onReject }: IncomingCallProps) {
  useEffect(() => {
    const audio = new Audio(ringSound);
    audio.loop = true;
    audio.play();
    return () => audio.pause();
  }, []);

  return (
    <div
      className="animate-fade-in fixed z-40 bottom-6 right-6 flex items-center justify-center flex-col px-10 py-5 rounded-[20px] bg-white/70 backdrop-blur"
      style={{ boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" }}
    >
      <h3 className="text-primary-2 text-[22px] font-semibold leading-7 font-alternative mb-5">
        Um colega quer estudar!
      </h3>
      <UserAvatar
        size={180}
        url={call.user1.avatar_url}
        name={call.user1.name}
        className="mb-1"
      />
      <div className="font-alternative text-lg font-medium leading-6 mb-5">
        {call.user1.name}
      </div>

      <div className="flex gap-5">
        <button
          type="button"
          onClick={onAccept}
          className="bg-alternative-2 text-white rounded p-3 hover:opacity-90"
        >
          <span className="sr-only">Aceitar</span>
          <MdPhone size={20} />
        </button>
        <button
          type="button"
          onClick={onReject}
          className="bg-red-500 text-white rounded p-3 hover:opacity-90"
        >
          <span className="sr-only">Rejeitar</span>
          <MdPhone size={20} style={{ transform: "rotate(135deg)" }} />
        </button>
      </div>
    </div>
  );
}
